export default __webpack_public_path__ + "static/media/main.d8aac4a1.png";